<template>
  <div class="bg-white p-8">
    <el-dialog
      title=""
      :visible.sync="centerDialogVisibleg"
      :before-close="handleclose"
      width="45%"
      center
    >
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">Add Authors</h2>
      </template>
      <el-form :model="form" :rules="rules" ref="form">
        <div>
          <div class="mb-6">
            <lable> Course Icon</lable>
            <el-upload
              class="upload-demo w-full mt-3"
              drag
              ref="imageUploader"
              accept="image/*"
              :before-upload="handleuploadcoverimage"
              single
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload>
            <div v-if="renderedImage != null && files != ''" class="relative">
              <img
                :src="renderedImage"
                alt="preview image"
                class="w-full bg-gray object-contain h-60"
              />
              <div class="absolute top-2 right-4 bg-white rounded-full p-1">
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="handlesingleimage"
                />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <lable>Course Name</lable>
            <el-form-item
              prop="name"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' Course Name cannot be Empty.',
                  trigger: 'blur',
                },
                {
                  pattern: /^[a-zA-Z ]*$/,
                  message: ' name must Contain Alpahbets only',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.name"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="mb-3">
              <lable>Author Name</lable>
              <el-form-item
                prop="author"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' author cannot be Empty.',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="form.author"
                  placeholder="Select"
                  class="mt-2 w-full"
                >
                  <el-option
                    v-for="item in this.authorList"
                    :key="item.name"
                    :label="item.name"
                    :value="item._id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="mb-3">
              <lable>Course Categories</lable>
              <el-form-item
                prop="category"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' author cannot be Empty.',

                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="form.category"
                  placeholder="Select"
                  class="mt-2 w-full"
                >
                  <el-option
                    v-for="item in this.categoryList"
                    :key="item.name"
                    :label="item.name"
                    :value="item._id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="mb-3">
            <lable> course Description</lable>
            <el-form-item
              prop="about"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' author cannot be Empty.',

                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                :rows="2"
                class="mt-2 w-full"
                placeholder="Please input"
                v-model="form.about"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Course Content</lable>
            <el-form-item
              prop="content"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' Course Content cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <quill-editor
                v-model="form.content"
                :options="editorOption"
                class="quill-h200px mt-2"
              />
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Total Hours</lable>
            <el-form-item
              prop="hour"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' hour cannot be Empty.',

                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.hour"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>

          <div class="mb-3">
            <lable>Course Description</lable>
            <el-form-item
              prop="description"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' hour cannot be Empty.',

                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                :rows="2"
                class="mt-2 w-full"
                placeholder="Please input"
                v-model="form.description"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Certificate</lable>
            <div class="grid grid-cols-1 gap-3 mt-2">
              <el-form-item
                prop="certificate"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' certificate cannot be Empty.',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-radio
                  v-model="form.certificate"
                  label="On Approval"
                  class="fsize12"
                  >On Approval</el-radio
                >

                <el-radio
                  v-model="form.certificate"
                  label="On Completion"
                  class="fsize12"
                  >On Completion</el-radio
                >
              </el-form-item>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="mb-3">
              <lable>Course Render Level</lable>
              <el-form-item
                prop="level"
                class=""
                :rules="[
                  {
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="form.level"
                  placeholder="Select"
                  class="mt-2 w-full"
                >
                  <el-option
                    v-for="item in this.Level"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="mb-3">
              <lable>Course Language</lable>
              <el-form-item
                prop="language"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' language cannot be Empty.',

                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="form.language"
                  placeholder="Select"
                  class="mt-2 w-full"
                >
                  <el-option
                    v-for="item in this.Language"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="mb-3">
              <lable>Actual Rate (In INR)</lable>
              <el-form-item
                prop="price"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' price cannot be Empty.',

                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  placeholder="Please input"
                  v-model="form.price"
                  class="mt-2 w-full"
                >
                </el-input>
              </el-form-item>
            </div>
            <div class="mb-3">
              <lable>Discount (in %)</lable>
              <el-form-item
                prop="discount"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' discount cannot be Empty.',

                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  placeholder="Please input"
                  v-model="form.discount"
                  class="mt-2 w-full"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="mb-3">
              <lable>Discount Rate (In INR)</lable>
              <el-form-item
                prop="rate"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' rate cannot be Empty.',

                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  placeholder="Please input"
                  v-model="form.rate"
                  class="mt-2 w-full"
                >
                </el-input>
              </el-form-item>
            </div>
            <div class="mb-3">
              <lable>Choose Platform</lable>
              <el-form-item
                prop="platform"
                class=""
                :rules="[
                  {
                    required: true,
                    message: ' platform cannot be Empty.',

                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="form.platform"
                  placeholder="Select"
                  class="mt-2 w-full"
                >
                  <el-option
                    v-for="item in this.Platform"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="flex mt-6 gap-3 justify-end">
            <vs-button
              type="primary"
              class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
              @click="handleCategoryError('form')"
            >
              Save & Changes
            </vs-button>
            <vs-button
              type="secondary"
              class="rounded-lg bg-secondary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="" :visible.sync="centerDialogVisible" width="45%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">Edit</h2>
      </template>
      <div>
        <div class="mb-6">
          <lable> Course Icon</lable>
          <el-upload
            class="upload-demo w-full mt-3"
            drag
            ref="imageUploader"
            accept="image/*"
            :before-upload="handleuploadcoverimage"
            single
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
          <div v-if="renderedImage != null && files != ''" class="relative">
            <img
              :src="renderedImage"
              alt="preview image"
              class="w-full bg-gray object-contain h-60"
            />
            <div class="absolute top-2 right-4 bg-white rounded-full p-1">
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="handlesingleimage"
              />
            </div>
          </div>
          <div v-if="iconeUrl != ''" class="relative">
            <img
              :src="imageURL + iconeUrl"
              alt="preview image"
              class="w-full bg-gray object-contain h-60"
            />
            <div class="absolute top-2 right-4 bg-white rounded-full p-1">
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="iconeUrl = ''"
              />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <lable>Course Name</lable>
          <el-input
            placeholder="Enter"
            v-model="form.name"
            class="rounded-none mt-2 w-full"
          ></el-input>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div class="mb-3">
            <lable>Author Name</lable>
            <el-select
              v-model="form.author"
              placeholder="Select"
              class="mt-2 w-full"
            >
              <el-option
                v-for="item in this.authorList"
                :key="item.name"
                :label="item.name"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mb-3">
            <lable>Course Categories</lable>
            <el-select
              v-model="form.category"
              placeholder="Select"
              class="mt-2 w-full"
            >
              <el-option
                v-for="item in this.categoryList"
                :key="item.name"
                :label="item.name"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="mb-3">
          <lable> course Description</lable>
          <el-input
            type="textarea"
            :rows="2"
            class="mt-2 w-full"
            placeholder="Please input"
            v-model="form.about"
          >
          </el-input>
        </div>
        <div class="mb-3">
          <lable>Course Content</lable>
          <quill-editor
            v-model="form.content"
            :options="editorOption"
            class="quill-h200px mt-2"
          />
        </div>
        <div class="mb-3">
          <lable>Total Hours</lable>
          <el-input
            placeholder="Enter"
            v-model="form.hour"
            class="rounded-none mt-2 w-full"
          ></el-input>
        </div>

        <div class="mb-3">
          <lable>Course Description</lable>
          <el-input
            type="textarea"
            :rows="2"
            class="mt-2 w-full"
            placeholder="Please input"
            v-model="form.description"
          >
          </el-input>
        </div>
        <div class="mb-3">
          <lable>Certificate</lable>
          <div class="grid grid-cols-1 gap-3 mt-2">
            <el-radio
              v-model="form.certificate"
              label="On Approval"
              class="fsize12"
              >On Approval</el-radio
            >
            <el-radio
              v-model="form.certificate"
              label="On Completion"
              class="fsize12"
              >On Completion</el-radio
            >
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div class="mb-3">
            <lable>Course Render Level </lable>
            <el-select
              v-model="form.level"
              placeholder="Select"
              class="mt-2 w-full"
            >
              <el-option
                v-for="item in this.Level"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mb-3">
            <lable>Course Language</lable>
            <el-select
              v-model="form.language"
              placeholder="Select"
              class="mt-2 w-full"
            >
              <el-option
                v-for="item in this.Language"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div class="mb-3">
            <lable>Actual Rate (In INR)</lable>
            <el-input
              placeholder="Please input"
              v-model="form.price"
              class="mt-2 w-full"
            >
            </el-input>
          </div>
          <div class="mb-3">
            <lable>Discount (in %)</lable>
            <el-input
              placeholder="Please input"
              v-model="form.discount"
              class="mt-2 w-full"
            >
            </el-input>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div class="mb-3">
            <lable>Discount Rate (In INR)</lable>
            <el-input
              placeholder="Please input"
              v-model="form.rate"
              class="mt-2 w-full"
            >
            </el-input>
          </div>
          <div class="mb-3">
            <lable>Choose Platform</lable>
            <el-select
              v-model="form.platform"
              placeholder="Select"
              class="mt-2 w-full"
            >
              <el-option
                v-for="item in this.Platform"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex mt-6 gap-3 justify-end">
          <vs-button
            type="primary"
            class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
            @click="onSubmitUpdate"
          >
            Save & Changes
          </vs-button>
          <vs-button
            type="secondary"
            class="rounded-lg bg-secondary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
          >
            Cancel
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <div class="flex w-full">
      <!-- <div class="flex items-center gap-2">  
        <vs-button
          variant="primary"
          @click="centerDialogVisibleg = true"
          class="rounded-lg bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
        >
          Add Courses
        </vs-button>
      </div> -->
    </div>
    <div class="flex mt-4 gap-6 w-full">
      <div class="relative w-1/4">
        <el-input
          placeholder="Search"
          v-model="Search"
          class="rounded-none"
        ></el-input>
        <div class="absolute top-0 right-0 mt-2 mr-2">
          <feather-icon icon="SearchIcon" class="" />
        </div>
      </div>
      <div class="relative w-1/5">
        <el-select v-model="category" placeholder="Filter by Category">
          <el-option
            v-for="item in option"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative w-1/5">
        <el-select v-model="subject" placeholder="Filter by Subject">
          <el-option
            v-for="item in option1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative w-1/5">
        <el-select v-model="language" placeholder="Filter by Language">
          <el-option
            v-for="item in option2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative w-32">
        <el-select v-model="sort" class="" placeholder="Sort By">
          <el-option
            v-for="item in option3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="mt-5">
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column prop="srno" label="Sr. no" width="100">
        </el-table-column>
        <el-table-column prop="coursename" label="Course Name" width="165">
        </el-table-column>
        <el-table-column prop="category" label="Category" width="165">
        </el-table-column>
        <el-table-column prop="subcategory" label="Sub-Category" width="210">
        </el-table-column>
        <el-table-column prop="topic" label="Topic" width="130">
        </el-table-column>
        <el-table-column prop="chapters" label="Chapters" width="130">
        </el-table-column>
        <el-table-column prop="price" label="Price" width="100">
        </el-table-column>
        <el-table-column prop="action" label="Action">
          <el-button type="primary" plain class="actcolor">Publish</el-button>
          <!-- <el-button type="primary" plain class="actcolor">Unpublish</el-button> -->
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="grid grid-cols-3 gap-4 mt-4">
      <div class="" v-for="(item, index) in courseList" :key="'item -' + index">
        <div class="p-2 border rounded-lg">
          <div class="w-full">
            <img
              :src="imageURL + item.icone"
              alt="grid"
              class="w-full tempselect-cs bg-fas rounded-lg"
            />
            <div class="mt-3 p-2">
              <h2 class="fsize20 text-dark font-semibold">{{ item.name }}</h2>
              <div class="mt-4 flex items-center gap-2">
                <h6 class="text-md text-primary font-semibold">Duration:</h6>
                <p class="text-md text-gray font-normal">{{ item.duration }}</p>
              </div>
              <div class="mt-1 flex items-center gap-2">
                <h6 class="text-md text-primary font-semibold">Author:</h6>
                <p class="text-md text-gray font-normal">
                  {{ item.authorDetails.name }}
                </p>
              </div>
              <p class="fsize12 lineclamp-2 text-gray mt-2 font-normal">
                {{ item.description }}
              </p>
              <div class="w-3/12 my-3">
                <p class="fsize12 px-2 py-1 rounded-full bg-light-green">
                  Approved
                </p>
              </div>
              <div class="mt-1 flex justify-between w-full">
                <div class="mt-1 flex items-center gap-2">
                  <h6 class="text-md text-gray font-semibold">
                    {{ item.discountPrice }}
                  </h6>
                  <p class="text-md text-gray line-through font-normal">
                    {{ item.price }}
                  </p>
                </div>
                <div class="mt-1 flex items-center gap-2">
                  <div
                    class="cursor-pointer"
                    @click="centerDialogVisible = true"
                  >
                    <feather-icon
                      class="bg-light-green w-8 h-8 rounded-full flex justify-center items-center"
                      icon="EditIcon"
                      svgClasses="w-4 h-4"
                      @click="handleEdit(item._id)"
                    />
                  </div>
                  <div class="cursor-pointer">
                    <feather-icon
                      class="text-danger bg-light-danger w-8 h-8 rounded-full flex justify-center items-center"
                      icon="TrashIcon"
                      svgClasses="w-4 h-4"
                      @click="handleDelete(item._id)"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-1 flex w-full items-center gap-3 mt-4">
                <div class="w-1/2" @click="handlecustomize(item._id, item)">
                  <vs-button
                    variant="primary"
                    class="rounded-lg bg-primary border-0 text-white font-semibold py-2 w-full sm-fsize14"
                  >
                    Customize
                  </vs-button>
                </div>
                <div class="w-1/2">
                  <vs-button
                    @click="handleClick('attendance')"
                    variant="primary"
                    class="rounded-lg bg-primary border-0 text-white font-semibold py-2 w-full sm-fsize14"
                  >
                    Attendance
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      input: "",
      editorOption: {},
      courseid: null,
      iconeUrl: "",
      Search: "",
      authorid: null,
      centerDialogVisibleg: false,
      centerDialogVisible: false,
      imageUrl: "",
      radio: "1",
      rules: "",
      names: "",
      form: {
        name: "",
        about: "",
        rate: "",
        author: "",
        category: "",
        discount: "",
        certificate: "",
        price: "",
        description: "",
        hour: "",
        content: "",
        language: "",
        platform: "",
        level: "",
      },
      files: "",
      renderedImage: "",
      Language: [
        {
          value: "Hindi",
          label: "Hindi",
        },
        {
          value: "English",
          label: "English",
        },
        {
          value: "Spanish",
          label: "Spanish",
        },
      ],
      Platform: [
        {
          value: "TV",
          label: "TV",
        },
        {
          value: "Mobile",
          label: "Mobile",
        },
        {
          value: "Desktop",
          label: "Desktop",
        },
        {
          value: "Browser",
          label: "Browser",
        },
      ],
      Level: [
        {
          value: "Beginner",
          label: "Beginner",
        },
        {
          value: "Medium",
          label: "Medium",
        },
        {
          value: "High",
          label: "High",
        },
      ],
      value: "",
      category: "",
      subject: "",
      language: "",
      sort: "",
      option: [
        {
          value: "Option1",
          label: "Option1",
        },
      ],
      option1: [
        {
          value: "Option1",
          label: "Option1",
        },
      ],
      option2: [
        {
          value: "Option1",
          label: "Option1",
        },
      ],
      option3: [
        {
          value: "Option1",
          label: "Option1",
        },
      ],
      tableData: [
        {
          srno: "1",
          coursename: "UI Design",
          topic: "UI UX",
          category: "Design",
          subcategory: "User research For Design",
          chapters: "8",
          price: "₹800",
          // action: "Publish",
        },
        {
          srno: "2",
          coursename: "UI Design",
          topic: "UI UX",
          category: "Design",
          subcategory: "User research For Design",
          chapters: "8",
          price: "₹800",
          // action: "Publish",
        },
        {
          srno: "3",
          coursename: "UI Design",
          topic: "UI UX",
          category: "Design",
          subcategory: "User research For Design",
          chapters: "8",
          price: "₹800",
          // action: "Publish",
        },
      ],
    };
  },
  watch: {
    Search() {
      this.getcourseList();
    },
  },
  computed: {
    ...mapState("eLearningCategory", ["categoryList"]),
    ...mapState("eLearningAuthor", ["authorList"]),
    ...mapState("eLearningCourse", ["courseList", "courseDetails"]),

    discountPrice() {
      return this.price && this.discount
        ? this.price - (this.price / 100) * this.discount
        : 0;
    },
    imageURL() {
      return "https://nimbus-server-01.s3.ap-south-1.amazonaws.com";
    },
  },
  methods: {
    async handlecustomize(valid, item) {
      try {
        const payload = {
          id: item._id,
        };
        let data = await this.$store.dispatch(
          "elearningchapter/GetChapterByCourseId",
          payload
        );
        if (data.code == 200) {
          this.$router.push({
            name: "customize",
            params: { id: valid },
          });
        }
      } catch (err) {}
    },
    handleclose() {
      (this.centerDialogVisibleg = false),
        (this.centerDialogVisible = false),
        this.$refs["form"].resetFields();
      this.reset();
    },
    reset() {
      this.courseid = "";
      this.form.name = "";
      this.form.about = "";
      this.form.rate = "";
      this.form.author = "";
      this.authorid = "";
      this.form.category = "";
      this.form.certificate = "";
      this.form.price = "";
      this.form.description = "";
      this.form.hour = "";
      this.form.content = "";
      this.form.language = "";
      this.form.platform = "";
      this.form.level = "";
      this.iconeUrl = "";
      this.form.discount = "";
    },
    handleCategoryError(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.onSubmit();
        } else {
          return false;
        }
      });
    },
    ConfirmDelete() {
      return Swal.fire({
        title: `Are you sure you want to delete this?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#335080",
        cancelButtonColor: "#000000",
        confirmButtonText: "Yes",
      });
    },
    async handleEdit(data) {
      try {
        let payload = {
          courseID: data,
        };
        let data2 = await this.$store.dispatch(
          "eLearningCourse/getSingleCourse",
          payload
        );
        this.courseid = this.courseDetails[0]._id;
        this.form.name = this.courseDetails[0].name;
        this.form.about = this.courseDetails[0].aboutCourse;
        this.form.rate = this.courseDetails[0].discountPrice;
        this.form.author = this.courseDetails[0].authorDetails.name;
        this.authorid = this.courseDetails[0].authorDetails._id;
        this.form.category = this.courseDetails[0].categoryDetails.name;
        this.form.certificate = this.courseDetails[0].certificateType;
        this.form.price = this.courseDetails[0].price;
        this.form.description = this.courseDetails[0].description;
        this.form.hour = this.courseDetails[0].duration;
        this.form.content = this.courseDetails[0].content;
        this.form.language = this.courseDetails[0].language;
        this.form.platform = this.courseDetails[0].platform[0];
        this.form.level = this.courseDetails[0].level;
        this.iconeUrl = this.courseDetails[0].icone;
        this.form.discount = this.courseDetails[0].discountrate;
        // if (data2.code == 200) {
        //   this.centerDialogVisible = false
        //   this.$swal({
        //     text: "Course Updated Successfully",
        //     icon: "success",
        //     confirmButtonColor: "#cd3197",
        //     // confirmButtonColor: "#830c81",
        //     // cancelButtonColor: "#d33",
        //     confirmButtonText: "Okay",
        //   });
        // }
      } catch (error) {}
    },
    async handleDelete(data) {
      alert("true");
      let res = await this.ConfirmDelete();
      if (res.isConfirmed) {
        try {
          let payload = {
            courseID: data,
          };
          //await this.$store.dispatch('eLearningCourse/deleteCourse', payload)
        } catch (error) {}
      }
    },
    handlesingleimage() {
      this.renderedImage = null;
      this.files = "";
    },
    async handleuploadcoverimage(files) {
      this.iconeUrl = "";
      this.files = files;

      await this.readerData(files);
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmitUpdate() {
      let payload = new FormData();
      payload.append("name", this.form.name);
      payload.append("description", this.form.description);
      payload.append("icone", this.files);
      payload.append("language", this.form.language);
      payload.append("certificate", this.form.certificate);
      payload.append("level", this.form.level);
      payload.append("platform", this.form.platform);
      payload.append("duration", this.form.hour);
      payload.append("price", this.form.price);
      payload.append("discountPrice", this.form.rate);
      payload.append("content", this.form.content);
      payload.append("discountinr", this.form.price);
      payload.append("discountrate", this.form.discount);

      payload.append("author", this.authorid);
      payload.append("category", this.form.category);
      payload.append("_id", this.courseid);
      let data = await this.$store.dispatch(
        "eLearningCourse/updateCourse",
        payload
      );
      if (data.code == 200) {
        this.centerDialogVisible = false;
        this.getsuccessmessage("Course Created Successfully", "success");
      }
    },
    getsuccessmessage(message, type) {
      this.$swal({
        text: message,
        icon: type,
        confirmButtonColor: "#cd3197",
        //confirmButtonColor: "#830c81",
        // cancelButtonColor: "#d33",
        confirmButtonText: "Okay",
      });
    },
    async onSubmit() {
      this.addCourse();
    },
    async addCourse() {
      try {
        let payload = new FormData();

        payload.append("name", this.form.name);
        payload.append("description", this.form.description);
        payload.append("icone", this.files);
        payload.append("language", this.form.language);
        payload.append("certificate", this.form.certificate);
        payload.append("level", this.form.level);
        payload.append("platform", this.form.platform);
        payload.append("duration", this.form.hour);
        payload.append("price", this.form.price);
        payload.append("discountPrice", this.form.rate);
        payload.append("content", this.form.content);
        payload.append("author", this.form.author);
        payload.append("category", this.form.category);
        payload.append("aboutCourse", this.form.about);

        let data = await this.$store.dispatch(
          "eLearningCourse/createCourse",
          payload
        );
        if (data.code == 200) {
          this.centerDialogVisibleg = false;
          await this.getcourseList();
          this.$swal({
            text: "Course Created Successfully",
            icon: "success",
            confirmButtonColor: "#cd3197",
            //confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        }
      } catch (error) {}
    },
    async getcourseList() {
      try {
        const payload = {};
        if (this.Search != "") Object.assign(payload, { search: this.Search });
        await this.$store.dispatch("eLearningCourse/getAllCourse", payload);
      } catch (error) {}
    },
    async getCategoryData() {
      try {
        await this.$store.dispatch("eLearningCategory/getAllCategoryList");
        this.fo;
      } catch (error) {}
    },
    async getAuthorData() {
      try {
        await this.$store.dispatch("eLearningAuthor/getAllAuthorList");
      } catch (error) {}
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  async mounted() {
    this.getAuthorData();
    this.getCategoryData();
    this.getcourseList();
  },
};
</script>
